// frontend/src/components/Conexiones.jsx

import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  Select,
  Button,
  Typography,
  Space,
  message,
  Collapse,
  Tooltip,
  Popconfirm
} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;
const { Title, Text } = Typography;
const { Panel } = Collapse;

export default function Conexiones() {
  const [conexiones, setConexiones] = useState([]);
  const [nueva, setNueva] = useState({
    nombre: "",
    tipo: "graph",
    siteUrl: "",
    listName: ""
  });

  const fetchConexiones = async () => {
    try {
      const res = await axios.get("/api/connections");
      setConexiones(res.data || []);
    } catch {
      message.error("No se pudieron cargar las conexiones.");
    }
  };

  const crearConexion = async () => {
    const payload = {
      connection_name: nueva.nombre.trim(),
      type: nueva.tipo,
      site_url: nueva.siteUrl.trim(),
      list_name: nueva.listName.trim()
    };

    if (!payload.connection_name || !payload.site_url || !payload.list_name) {
      message.warning("Todos los campos son obligatorios.");
      return;
    }

    try {
      await axios.post("/api/connections", payload);
      setNueva({ nombre: "", tipo: "graph", siteUrl: "", listName: "" });
      message.success("✅ Conexión creada correctamente.");
      fetchConexiones();
    } catch (error) {
      message.error(error?.response?.data?.message || "Error al crear la conexión.");
    }
  };

  const eliminarConexion = async (nombre) => {
    try {
      await axios.delete(`/api/connections/${nombre}`);
      message.success(`Conexión '${nombre}' eliminada.`);
      fetchConexiones();
    } catch {
      message.error("Error al eliminar la conexión.");
    }
  };

  const ejemploJSON = (operacion, connName) => {
    const base = {
      operation: operacion,
      connection: connName,
      params: {}
    };

    if (operacion === "create") {
      base.params.data = { Title: "Nuevo" };
    }

    if (operacion === "update") {
      base.params.item_id = 1;
      base.params.data = { Title: "Modificado" };
    }

    if (operacion === "bulk_create") {
      base.params.items = [
        { Title: "Elemento 1", Estado: "Pendiente" },
        { Title: "Elemento 2", Estado: "Completado" }
      ];
    }

    return JSON.stringify(base, null, 2);
  };

  useEffect(() => {
    fetchConexiones();
  }, []);

  return (
    <div style={{ padding: "0rem 1rem 1rem", maxWidth: 1000, margin: "0 auto" }}>
      <Title level={3}>🔗 Conexiones</Title>

      <Card title="➕ Nueva conexión" style={{ marginBottom: 24 }}>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Input
            placeholder="Nombre de la conexión"
            value={nueva.nombre}
            onChange={(e) => setNueva({ ...nueva, nombre: e.target.value })}
          />
          <Select
            value={nueva.tipo}
            onChange={(value) => setNueva({ ...nueva, tipo: value })}
            style={{ width: "100%" }}
          >
            <Option value="graph">Graph</Option>
            <Option value="rest">REST</Option>
          </Select>
          <Input
            placeholder="URL del sitio SharePoint"
            value={nueva.siteUrl}
            onChange={(e) => setNueva({ ...nueva, siteUrl: e.target.value })}
          />
          <Input
            placeholder="Nombre de la lista SharePoint"
            value={nueva.listName}
            onChange={(e) => setNueva({ ...nueva, listName: e.target.value })}
          />
          <Button type="primary" icon={<PlusOutlined />} onClick={crearConexion}>
            Guardar conexión
          </Button>
        </Space>
      </Card>

      {conexiones.map((conn) => (
        <Card
          key={conn.connection_name}
          title={
            <Space direction="vertical" size={0}>
              <Text strong>{conn.connection_name}</Text>
              <Text type="secondary">Tipo: {conn.type}</Text>
            </Space>
          }
          extra={
            <Popconfirm
              title="¿Eliminar esta conexión?"
              onConfirm={() => eliminarConexion(conn.connection_name)}
              okText="Sí"
              cancelText="No"
            >
              <Tooltip title="Eliminar conexión">
                <Button type="text" danger icon={<DeleteOutlined />} />
              </Tooltip>
            </Popconfirm>
          }
          style={{ marginBottom: 16 }}
        >
          <Collapse ghost>
            <Panel header="📄 Ejemplos de uso (READ / CREATE / UPDATE / BULK_CREATE)" key="1">
              <Text strong>READ:</Text>
              <pre>{ejemploJSON("read", conn.connection_name)}</pre>
              <Text strong>CREATE:</Text>
              <pre>{ejemploJSON("create", conn.connection_name)}</pre>
              <Text strong>UPDATE:</Text>
              <pre>{ejemploJSON("update", conn.connection_name)}</pre>
              <Text strong>BULK_CREATE:</Text>
              <pre>{ejemploJSON("bulk_create", conn.connection_name)}</pre>
            </Panel>
          </Collapse>
        </Card>
      ))}
    </div>
  );
}
